import { cn } from "@/lib/utils";

export const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const SOURCE_COLOR = { total_operations: "#0f766e", google_workspace: "#d97706", slack: "#7c3aed", crm_external: "#2563eb", other: "#64748b" };
export const SOURCE_LABEL = { total_operations: "Total Operations", google_workspace: "Google Workspace", slack: "Slack", crm_external: "External CRM", other: "Other" };

export function fmtTime(iso) {
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return iso; }
}

export function Stat({ label, value, sub, accent, testid }) {
  return (<div className="rounded-xl border bg-white p-3.5" style={{ borderColor: "var(--line)" }} data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wider text-slate-400">{label}</div>
    <div className="font-heading text-2xl font-semibold tabular mt-0.5" style={accent ? { color: accent } : {}}>{value ?? "—"}</div>
    {sub != null && <div className="text-xs text-slate-500 mt-0.5">{sub}</div>}
  </div>);
}

export function CoverageChip({ pct, testid }) {
  if (pct == null) return null;
  const tone = pct >= 90 ? "border-teal-300 text-teal-700 bg-teal-50" : pct >= 75 ? "border-amber-300 text-amber-700 bg-amber-50" : "border-rose-300 text-rose-700 bg-rose-50";
  const conf = pct >= 90 ? "High confidence" : pct >= 75 ? "Medium confidence" : "Low confidence";
  return <span className={cn("chip text-[11px]", tone)} data-testid={testid}>Signal coverage {pct}% · {conf}</span>;
}
